export default "__VITE_ASSET__BivXsAZM__"